import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Acm } from "app/models/loyalty-acm.model";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { FormFields } from "app/views/campaign-3/components/form-fields/form-fields.component";
import { Accumulator3Service } from "app/views/campaign-3/services/accumulator3.service";
import { AcmChannel, Campaign3TestService } from "app/views/campaign-3/services/campaign3testservice";



interface FieldModel {
  start_date: Date | null;
  end_date: Date | null;
  date_pti_start: Date | null;
  date_pti_end: Date | null;
  flg_ext_circ: boolean | null;
  channel: any | null;
}


@Component({
  selector: 'app-acm-channel-new-3',
  templateUrl: './acm-channel-new-3.component.html',
  styleUrls: ['./acm-channel-new-3.component.css']
})
export class AcmChannelNew3Component implements OnInit {


  @ViewChild('start_date') startDate: FormFields;
  @ViewChild('end_date') endDate: FormFields;
  @ViewChild('date_pti_start') datePtiStart: FormFields;
  @ViewChild('date_pti_end') datePtiEnd: FormFields;

  @ViewChild('acm_channel') channel: FormFields;

  popupError: boolean = false;
  dateOrderError: boolean = false;
  dateOrderMessage: string = "*End date minore di StartDate"

  dateOrderAccError: boolean = false;
  dateOrderAccMessage: string = "*EndAccDate minore di StartAccDate"

  missingChannel: boolean = false;
  missingChannelMessage: string = "Selezionare almeno un canale"


  dateformat = 'yyyy-MM-dd';

  @Input() listChannel;
  @Input() fatherAcmChannel: any;
  @Output() refreshPage = new EventEmitter();
  @Output() closeCreationPopup = new EventEmitter<any>();


  newFieldModel: FieldModel = {

    start_date: null,
    end_date: null,
    date_pti_start: null,
    date_pti_end: null,
    flg_ext_circ: null,
    channel: null
  };

  errors = {
    acmDescription: false,
    start_date: false,
    end_date: false,
    date_pti_start: false,
    date_pti_end: false,
    flg_ext_circ: false,
    channel: false
  };

  ngOnInit(): void {
    console.log('fatherAcmChannel:', this.fatherAcmChannel);
    console.log('listChannel:', this.listChannel);
   
    if (this.fatherAcmChannel) {
      this.newFieldModel = {
        start_date: new Date(this.fatherAcmChannel.dateStart) || null,
        end_date: new Date(this.fatherAcmChannel.dateEnd) || null,
        date_pti_start: new Date(this.fatherAcmChannel.datePtiStart) || null,
        date_pti_end: new Date(this.fatherAcmChannel.datePtiEnd) || null,
        flg_ext_circ: false,
        channel: this.listChannel.find(x => x.value == this.fatherAcmChannel.id) || null

      };
    }


    console.log('newFieldModel', this.newFieldModel);
  }

  constructor(
    public testService: Campaign3TestService,
    private accService: Accumulator3Service,
    public srvCalendar: CalendarTranslateService,
    private datePipe: DatePipe) {
  }

  OnSaveEntity() {
    this.dateOrderError = false;
    this.dateOrderAccError = false;
    this.missingChannel = false;

    this.startDate.performValidation();
    this.endDate.performValidation();
    this.datePtiStart.performValidation();
    this.datePtiEnd.performValidation();



    this.validateFields();

    // Verifico se oggetto error ha dei parametri settati a true
    const errorValues = Object.keys(this.errors).map(key => this.errors[key]);
    const hasErrors = errorValues.some(error => error);
    console.log(hasErrors);
    // Se ci sono errori, non salvare l'entità e aprire popup
    if (hasErrors) {
      console.log("abort saving, there are some errors", this.newFieldModel);
      this.popupError = true;

      for (const key in this.errors) {
        if (Object.prototype.hasOwnProperty.call(this.errors, key)) {
          this.errors[key] = false;

        }
      }
      return;
    }
    let newAcmChannel = new AcmChannel();


    newAcmChannel.acm_id = parseInt(this.fatherAcmChannel.id);
    newAcmChannel.date_start = this.datePipe.transform(this.newFieldModel.start_date, this.dateformat);
    newAcmChannel.date_end = this.datePipe.transform(this.newFieldModel.end_date, this.dateformat);
    newAcmChannel.date_pti_start = this.datePipe.transform(this.newFieldModel.date_pti_start, this.dateformat);
    newAcmChannel.date_pti_end = this.datePipe.transform(this.newFieldModel.date_pti_end, this.dateformat);
    newAcmChannel.flg_ext_circ = this.newFieldModel.flg_ext_circ ? "1" : "0";


    newAcmChannel.channel_id = this.listChannel.find(x => x.value == this.newFieldModel.channel.value).value;

    console.log(newAcmChannel);
    this.accService.saveAcmLoyChannel(newAcmChannel).subscribe(
      res => {
        console.log(res);
        this.refreshPage.emit(this.fatherAcmChannel);
        this.closeCreationPopup.emit()
      }
   
    );

   



}


onClosePopup(){
  this.closeCreationPopup.emit();
}


onChangeStartDate(date: Date) {
  this.newFieldModel.start_date = date;
}
onChangeStartAccDate(date: Date) {
  this.newFieldModel.date_pti_start = date;
}
onChangeEndDate(date: Date) {
  this.newFieldModel.end_date = date;
}
onChangeEndAccDate(date: Date) {
  this.newFieldModel.date_pti_end = date;
}
validateFields() {

  // Controllo per ciascun campo
  for (const field in this.newFieldModel) {
    if (field === 'flg_ext_circ') {
      continue; // Salta il controllo per flg_ext_circ perchè può essere nullo
    }
    if (!this.newFieldModel[field]) {
      this.errors[field] = true;
    } else {
      this.errors[field] = false;
    }
  }

  // Controllo della relazione tra start_date e end_date
  if (this.newFieldModel.start_date && this.newFieldModel.end_date) {
    const startDate = new Date(this.newFieldModel.start_date);
    const endDate = new Date(this.newFieldModel.end_date);
    if (startDate > endDate) {
      this.errors.start_date = true;
      this.errors.end_date = true;
      this.dateOrderError = true;

    }
  }
  if (this.newFieldModel.date_pti_start && this.newFieldModel.date_pti_end) {
    const startDate = new Date(this.newFieldModel.date_pti_start);
    const endDate = new Date(this.newFieldModel.date_pti_end);
    if (startDate > endDate) {
      this.errors.date_pti_start = true;
      this.errors.date_pti_end = true;
      this.dateOrderAccError = true;
    }
  }
  if (!this.newFieldModel.channel) {
    this.missingChannel = true;
  }
}



}


// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/acm-channel-new-3/acm-channel-new-3.component.ts